export const REQUEST_FETCH_EVENT_PERMALINK_EM =
  "REQUEST_FETCH_EVENT_PERMALINK_EM";
export const FETCH_EVENT_PERMALINK_EM_SUCCESS =
  "FETCH_EVENT_PERMALINK_EM_SUCCESS";
export const FETCH_EVENT_PERMALINK_EM_FAILURE =
  "FETCH_EVENT_PERMALINK_EM_FAILURE";

export const CLEAR_FETCH_EVENT_PERMALINK_EM_STATES =
  "CLEAR_FETCH_EVENT_PERMALINK_EM_STATES";
